export default "__VITE_ASSET__iFocuQ4F__"